<!-- 菜单列表 -->
<template>
<div style="width: 1100px;">
	<!-- 标题 -->
	<div class="page-title">菜单列表</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		<a-button @click="openClick" type="primary">展开</a-button>
		
		<a-button @click="stowClick" style="margin-left: 15px;" type="primary">收起</a-button>
		
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;margin-left: 15px;" type="primary">+ 新增</a-button>
	</div>
	
	<div v-for="(items,index) in menuData" :key="items.id" class="content-box">
		<!-- 一级 -->
		<div @click="firstTitle(index)" class="first-title-box" :style="{'border-bottom':(items.show_control && items.child.length > 0)?'1px solid #d9d9d9':'none',}">
			
			<a-icon v-show="!items.show_control && items.child.length > 0" class="first-title-icon" type="right" />
			<a-icon v-show="items.show_control && items.child.length > 0" class="first-title-icon" type="down" />
			<div style="font-size: 15px;display: flex;align-items: center;">{{items.title}}</div>
			
			
			<div style="color: #4c9ce7;margin-left: 30px;cursor: pointer;">{{items.uri}}</div>
			
			<div style="font-size: 14px;position: absolute;right: 125px;">排序值：{{items.order}}</div>
			<a-icon @click.stop="editButton(items)" style="position: absolute;right: 75px;padding: 5px;" type="form" />
			<a-icon v-show="items.show == 1" @click.stop="showHideButton(items)" style="position: absolute;right: 45px;padding: 5px;" type="eye" />
			<a-icon v-show="items.show != 1" @click.stop="showHideButton(items)" style="position: absolute;right: 45px;padding: 5px;" type="eye-invisible" />
			<a-icon @click.stop="delButton(items)" style="position: absolute;right: 15px;padding: 5px;" type="delete" />
		</div>
		
		<div v-show="(items.show_control && items.child.length > 0)" style="padding: 10px 0 10px 30px;">
			<!-- 二级 -->
			<div v-for="(item_z,index_z) in items.child" :key="index_z">
				<div @click="secondTitle(index,index_z)" class="title-box" :style="{cursor:item_z.child.length > 0?'pointer':'default'}">
					<a-icon v-show="!item_z.show_control && item_z.child.length > 0" class="first-title-icon" type="right" />
					<a-icon v-show="item_z.show_control && item_z.child.length > 0" class="second-title-icon" type="down" />
					<div style="font-size: 15px;">{{item_z.title}}</div>
					
					<div style="color: #4c9ce7;margin-left: 30px;cursor: pointer;">{{item_z.uri}}</div>
					
					<div style="font-size: 14px;position: absolute;right: 125px;">排序值：{{item_z.order}}</div>
					<a-icon @click.stop="editButton(item_z)" style="position: absolute;right: 75px;padding: 5px;" type="form" />
					<a-icon v-show="item_z.show == 1" @click.stop="showHideButton(item_z)" style="position: absolute;right: 45px;padding: 5px;" type="eye" />
					<a-icon v-show="item_z.show != 1" @click.stop="showHideButton(item_z)" style="position: absolute;right: 45px;padding: 5px;" type="eye-invisible" />
					<a-icon @click.stop="delButton(item_z)" style="position: absolute;right: 15px;padding: 5px;" type="delete" />
				</div>
				
				<div v-show="item_z.show_control && item_z.child.length > 0" style="padding-left: 30px;cursor: default;">
					<div v-for="(item_t,index_t) in item_z.child" :key="index_t" class="title-box" style="font-size: 14px;padding-left:20px;">
						{{item_t.title}}
						<div style="color: #4c9ce7;margin-left: 30px;cursor: pointer;">{{item_t.uri}}</div>
						
						<div style="font-size: 14px;position: absolute;right: 125px;">排序值：{{item_t.order}}</div>
						<a-icon @click.stop="editButton(item_t)" style="position: absolute;right: 75px;padding: 5px;" type="form" />
						<a-icon v-show="item_t.show == 1" @click.stop="showHideButton(item_t)" style="position: absolute;right: 45px;padding: 5px;" type="eye" />
						<a-icon v-show="item_t.show != 1" @click.stop="showHideButton(item_t)" style="position: absolute;right: 45px;padding: 5px;" type="eye-invisible" />
						<a-icon @click.stop="delButton(item_t)" style="position: absolute;right: 15px;padding: 5px;" type="delete" />
					</div>
				</div>
			</div>
			
		</div>
		
	</div>
	
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="700px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">
					父级
					<span class="required-hint">*</span>
				</div>
					
				<a-select :value="x_parent_id" style="width: 500px" placeholder="未选择"
				 @change="handleChangeA" >
				 <a-select-option  :value="0">
				 	顶级
				 </a-select-option>
					<a-select-option  v-for="(item,index) in fatherData" :key="item.id" :value="item.id">
						<span v-if="item.scd">---</span>
						{{item.label}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">标题<span class="required-hint">*</span></div>
					
				<a-input v-model="x_title" placeholder="请输入" style="width: 500px;"  />
			</div>
			
			<div class="form-cell-box" style="align-items: flex-start;">
				<div class="class-title">vue路径</div>
				
				<div>
					<div v-for="(item_v,index_v) in vueData" :key="item_v.id" style="width: 520px;display: flex;align-items: center;margin-bottom: 10px;">
						<a-select :value="item_v.vue_url" style="width: 365px" placeholder="未选择" showSearch
						 @change="handleChangeV($event,index_v)" allowClear :filter-option="filterOption">
							<a-select-option  v-for="(value_s,key_s) in vueSelect" :key="key_s" :value="value_s.id">
								{{value_s.vue_url}} -- {{value_s.name}}
							</a-select-option>
						</a-select>
						<div style="display: flex;align-items: center;margin-left: 10px;">
							排序：
							<a-input-number @change='vueSort($event,item_v)' :value="item_v.vue_sort" :min="0" :max="1000"  style="width: 60px;margin: 0 5px;" />
							
						</div>
						<a-icon @click="delVueUrl(item_v,index_v)" type="close-circle" style="font-size: 18px;cursor: pointer;margin-left: 10px;" />
					</div>
					<div>
						<a-button @click="addVueUrl()" type="primary" size="small" style="">
						    添加 +
						</a-button>
						
						<a-button @click="sortVueUrl()" type="primary" size="small" style="margin-left: 10px;">
						    整理排序
						</a-button>
					</div>
					
				</div>
				
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">显示/隐藏<span class="required-hint">*</span></div>
					
				<a-switch :checked="!!x_show" @change="showChange" checked-children="显示" un-checked-children="隐藏" default-checked />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">排序值</div>
					
				<a-input v-model="x_order" placeholder="请输入" type="number" style="width: 500px;" />
			</div>
			
			<!-- <div class="form-cell-box">
				<div class="class-title">API接口路径</div>
					
				<a-input v-model="x_uri" placeholder="请输入" style="width: 500px;"  />
			</div> -->
			
			<!-- <div class="form-cell-box">
				<div class="class-title">角色</div>
				<a-select
					:value="x_role_ids"
				    mode="multiple"
				    style="width: 500px"
				    placeholder="请选择"
				    @change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
				  >
				  
				    <a-select-option v-for="(item,key) in roleList" :key="key" :value="key">
				      {{item}}
				    </a-select-option>
				</a-select>
			</div> -->
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 25px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 删除提示框 -->
	<a-modal
	      title="确定要删除吗?"
	      :visible="del_visible"
	      :confirm-loading="del_modal_loading"
		  okType="danger"
		  cancelText="取消"
		  okText="删除"
	      @ok="delModalOk"
	      @cancel="delModalCancel"
	    >
	      <p>{{ del_text }}</p>
	    </a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { menuTree, menuAdd, menuEdit, UserSelectRole, menuDel, menuVueSelect } from '@/request/api'	
export default {
	name: 'menu_',
	components: {
		
	},
	data() {
		return {
			menuData: [],
			x_username: "",
			search_button_loading: false, // 加载中
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_id: "", // id
			x_parent_id: undefined, // 父类id
			x_title: "", // 标题
			x_uri: "", // API接口路径
			x_show: 1, // 是否展示0=否 1=是
			x_vue_url: undefined, // vue页面跳转路径
			x_role_ids: undefined, // 角色id数据role_ids = 【1,23】
			x_order: 0, // 排序字段，数字越小越靠前
			
			fatherData: [], // 新增侧边栏的父级下拉列表
			roleList: {}, // 角色下拉列表
			
			del_text: "", // 删除弹窗说明文字
			del_visible: false,
			del_modal_loading: false,
			
			vueUrl: [ // label只是用于下拉选择时，给用户标明页面的名字和归属。name是用于请求的，方便配置含tab格式页面时的tab名字配置
				{path:"/null",label:"不需要点击跳转就选这个", name: "",},
				{path:"/",label:"登录", name: "登录",},
				{path:"/dashboard",label:"投放排行", name: "投放排行",},
				{path:"/summary",label:"投放数据看板", name: "投放数据看板",},
				{path:"/assistant",label:"投放助理数据", name: "投放助理数据",},
				{path:"/effect",label:"投放效果跟踪", name: "投放效果跟踪",},
				{path:"/fansRank",label:"公众号新增粉丝排行榜", name: "公众号新增粉丝排行榜",},
				{path:"/panelWeek",label:"投放数据周维度看板", name: "投放数据周维度看板",},
				{path:"/pitcher",label:"投放数据统计—投手维度", name: "投放数据统计—投手维度",},
				{path:"/book",label:"投放数据统计—书籍维度", name: "投放数据统计—书籍维度",},
				{path:"/users",label:"用户列表", name: "用户列表",},
				{path:"/routes",label:"路由列表页面", name: "路由列表页面",},
				{path:"/roles",label:"角色列表", name: "角色列表",},
				{path:"/menu",label:"菜单列表", name: "菜单列表",},
				{path:"/loginLog",label:"登录日志", name: "登录日志",},
				{path:"/vuePath",label:"VUE路径管理页面", name: "VUE路径管理",},
				{path:"/landPage",label:"落地页管理", name: "落地页管理",},
				{path:"/landPageAdd",label:"落地页新增", name: "落地页新增",},
				{path:"/landAdd360",label:"360落地页新增", name: "360落地页新增",},
				{path:"/mediaList",label:"媒体列表管理", name: "媒体列表管理",},
				{path:"/mediaPosition",label:"媒体版位管理", name: "媒体版位管理",},
				{path:"/channelList",label:"渠道列表", name: "渠道列表",},
				{path:"/putGzh",label:"投放公众号", name: "投放公众号",},
				{path:"/accountTT",label:"头条巨量引擎 - 推广账户管理", name: "头条巨量引擎",},
				{path:"/accountOPPO",label:"OPPO - 推广账户管理", name: "OPPO",},
				{path:"/accountVIVO",label:"VIVO - 推广账户管理", name: "VIVO",},
				{path:"/accountTX",label:"腾讯 - 推广账户管理", name: "腾讯",},
				{path:"/accountBD",label:"百度 - 推广账户管理", name: "百度",},
				{path:"/orderGzh",label:"公众号订单 - 订单中心", name: "公众号订单",},
				{path:"/orderDZ",label:"点众快应用订单 - 订单中心", name: "点众快应用订单",},
				{path:"/orderCD",label:"常读快应用订单 - 订单中心", name: "常读快应用订单",},
				{path:"/orderWD",label:"文鼎快应用订单 - 订单中心", name: "文鼎快应用订单",},
				{path:"/registerGzh",label:"公众号注册用户 - 订单用户列表", name: "公众号注册用户",},
				{path:"/registerCd",label:"常读快应用注册用户 - 订单用户列表", name: "常读快应用注册用户",},
				{path:"/registerWd",label:"文鼎快应用注册用户 - 订单用户列表", name: "文鼎快应用注册用户",},
				{path:"/LPzj",label:"自建落地页用户 - 落地页用户", name: "自建落地页用户",},
				{path:"/LPjmy",label:"基木鱼用户 - 落地页用户", name: "基木鱼用户",},
				{path:"/LPjl",label:"巨量点击用户 - 落地页用户", name: "巨量点击用户",},
				{path:"/LP360",label:"360落地页用户 - 落地页用户", name: "360落地页用户",},
				{path:"/JLzh",label:"巨量引擎账户 - 巨量引擎", name: "账户",},
				{path:"/JLggz",label:"巨量引擎广告组 - 巨量引擎", name: "广告组",},
				{path:"/JLjh",label:"巨量引擎计划 - 巨量引擎", name: "计划",},
				{path:"/JLcy",label:"巨量引擎创意 - 巨量引擎", name: "创意",},
				{path:"/BDzh",label:"百度账户 - 百度", name: "账户",},
				{path:"/BDjh",label:"百度计划 - 百度", name: "计划",},
				{path:"/BDdy",label:"百度单元 - 百度", name: "单元",},
				{path:"/BDcy",label:"百度创意 - 百度", name: "创意",},
				{path:"/openGzh",label:"运营公众号管理", name: "运营公众号管理",},
				{path:"/xcxScheme",label:"小程序跳转码", name: "小程序跳转码",},
				{path:"/operateChannel",label:"运营书城渠道", name: "运营书城渠道",},
				{path:"/xcxOperate",label:"小程序管理-运营版", name: "小程序管理-运营版",},
				{path:"/xcxPut",label:"小程序管理-投手版", name: "小程序管理-投手版",},
				{path:"/xcxSchemeUse",label:"小程序跳转码每日使用量", name: "小程序跳转码每日使用量",},
				{path:"/xcxSchemeData",label:"小程序跳转码数量统计", name: "小程序跳转码数量统计",},
				{path:"/putLinkWd",label:"文鼎推广链接 - 快应用推广链接", name: "文鼎推广链接",},
				{path:"/putLinkCd",label:"常读推广链接 - 快应用推广链接", name: "常读推广链接",},
				{path:"/putLinkDz",label:"点众渠道 - 快应用推广链接", name: "点众渠道",},
				{path:"/pitcherDaily",label:"投手天级统计：巨量", name: "投手天级统计：巨量",},
				{path:"/marketersData",label:"设计天级统计：巨量", name: "设计天级统计：巨量",},
				{path:"/downTask",label:"下载任务", name: "下载任务",},
				{path:"/jlPlan",label:"巨量计划充值统计", name: "巨量计划充值统计",},
				{path:"/bdPlan",label:"百度单元充值统计", name: "百度单元充值统计",},
				{path:"/clickOPPO",label:"OPPO点击监测用户", name: "OPPO点击监测用户",},
				{path:"/clickVIVO",label:"VIVO点击监测用户", name: "VIVO点击监测用户",},
				{path:"/clickHUAWEI",label:"华为点击监测用户", name: "华为点击监测用户",},
				{path:"/clickWeibo",label:"微博点击监测用户", name: "微博点击监测用户",},
				{path:"/pitcherList",label:"设计师别名管理", name: "设计师别名管理",},
				{path:"/weiboPlan",label:"微博计划", name: "微博计划",},
				{path:"/taskSync",label:"同步任务列表", name: "同步任务列表",},
				{path:"/libraryList",label:"渠道书库", name: "渠道书库",},
				{path:"/libraryDown",label:"渠道书库下载任务", name: "渠道书库下载任务",},
				{path:"/pitcherLog",label:"投手操作日志", name: "投手操作日志",},
				{path:"/userInfor",label:"用户设置", name: "用户设置",},
				{path:"/dataDictionary",label:"数据字典", name: "数据字典",},
				{path:"/jumpQwQy",label:"跳转企业微信-企业列表", },
				{path:"/libraryDownParams",label:"渠道书库-下载参数管理", },
				{path:"/agentAdmin",label:"代理商管理", },
				{path:"/clickTxADQ",label:"腾讯ADQ点击用户", },
				{path:"/clickBD",label:"百度点击用户", },
				{path:"/putBook",label:"投放书籍", },
				{path:"/putLinkLd",label:"乐读推广链接", },
				{path:"/registerLd",label:"乐读快应用注册用户", },
				{path:"/orderLD",label:"乐读订单", },
				{path:"/JLproject",label:"巨量引擎2.0项目", },
				{path:"/JLpromotion",label:"巨量引擎2.0广告", },
				{path:"/TxAdvHc",label:"腾讯广告回传设置", },
				{path:"/landQuickApp",label:"快应用落地页管理", date:"2022.10.9"},
				{path:"/landQuickAppAdd",label:"快应用落地页新增/编辑", date:"2022.10.10"},
				{path:"/accountHW",label:"推广账户管理-华为", date:"2022.10.11"},
			],
			vueData: [
				{id: 'add1', name: "", vue_url: undefined, vue_sort: 1,},
			],
			vueSelect: {},
		}
	},
	mounted(){
		let that = this
		// console.log("vueUrl",that.vueUrl.length);
		that.searchButton()
		
		// 获取角色的下拉列表
		UserSelectRole().then(res=>{
			// console.log("角色下拉列表",res.data.data.list)
			let data = res.data.data.list
			let k_data = Object.keys(data)
			let r_data = []
			k_data.forEach(res=>{
				let obj = {
					key : res,
					value : data[res]
				}
				r_data.push(obj)
			})
			that.roleList = res.data.data.list
		})
		
		// console.log(this)
		
		menuVueSelect().then(res=>{
			console.log("获取vue下拉",res);
			that.vueSelect = res.data.data.list
		})
	},
	methods: {
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			menuTree().then(res=>{
				console.log("菜单列表",res.data.data.list)
				
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					// 处理新增侧边栏的父级项要显示的数据
					let data = res.data.data.list
					let fff = []
					data.forEach(res=>{
						let obj = {
							id: res.id,
							label: res.title,
							scd: false, // 是否要出现下级提示
						}
						fff.push(obj)
						res.show_control = true // 控制内容是否展示，true为显示
						res.child.forEach(res_c=>{
							let ooo = {
								id: res_c.id,
								label: res_c.title,
								scd: true, // 是否要出现下级提示
							}
							fff.push(ooo)
							res_c.show_control = true 
						})
					})
					// console.log("fff",fff)
					that.fatherData = fff
					that.menuData = data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 点击一级标题收起/展开
		firstTitle(index){
			let that = this
			console.log(that.menuData[index].show_control);
			that.menuData[index].show_control = !that.menuData[index].show_control
			
		},
		// 点击二级标题
		secondTitle(index,index_z){
			let that = this
			that.menuData[index].child[index_z].show_control = !that.menuData[index].child[index_z].show_control
		},
		// 展开
		openClick(){
			let that = this
			that.menuData.forEach(res=>{
				res.show_control = true // 控制内容是否展示，true为显示
				res.child.forEach(res_c=>{
					res_c.show_control = true 
				})
			})
		},
		// 收起
		stowClick(){
			let that = this
			that.menuData.forEach(res=>{
				res.show_control = false // 控制内容是否展示，true为显示
				res.child.forEach(res_c=>{
					res_c.show_control = false 
				})
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editButton(item){
			let that = this
			that.drawer_title = "编辑"
			console.log(item);
			that.x_id = item.id
			that.x_parent_id = item.parent_id // 父类id
			that.x_title = item.title // 标题
			// that.x_uri = item.uri // API接口路径
			that.x_show = item.show // 是否展示0=否 1=是
			// that.x_vue_url = item.vue_url // vue页面跳转路径
			that.x_order = item.order
			
			if(item.vues.length > 0){
				let vvv = []
				item.vues.forEach((res,index)=>{
					console.log(res);
					let obj = {
						vue_url: res.id,
						vue_sort: index + 1
					}
					vvv.push(obj)
				})
				that.vueData = vvv
			}
			else {
				that.vueData = [
					{id:'add1' ,name: "", vue_url: undefined, vue_sort: 1,},
				]
			}
			
			// let rrr = []
			// item.roles.forEach(res=>{
			// 	rrr.push(res.id.toString()) // 得是字符串类型的值
			// })
			// console.log("rrr",rrr);
			// that.x_role_ids = rrr // 角色id数据role_ids = 【1,23】
			that.x_role_ids = [] // 2022-8-11取消角色id数据
			
			that.visible = true
		},
		// 删除
		delButton(e){
			let that = this
			console.log(e.id);
			that.x_id = e.id
			that.del_text = `id：${e.id} --- ${e.title} `
			that.del_visible = true
			
		},
		// 删除弹窗确认
		delModalOk(){
			let that = this
			this.del_modal_loading = true
			menuDel({
				id: that.x_id
			}).then(res=>{
				console.log(res)
				if(res.data.code == 0){
					that.del_modal_loading = false
					that.del_visible = false
					that.$message.success('删除成功');
					that.searchButton()
				}
				
			})
		},
		// 删除弹窗取消
		delModalCancel(){
			if(this.del_modal_loading){
				return
			}
			
			this.del_visible = false
		},
		// 侧边栏关闭
		onCloseDrawer(){
			let that = this
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			that.x_parent_id = undefined // 父类id
			that.x_title = "" // 标题
			that.x_uri = "" // API接口路径
			that.x_show = 1 // 是否展示0=否 1=是
			that.x_vue_url = undefined // vue页面跳转路径
			that.x_role_ids = undefined
			that.x_order = 0
			this.add_form_hint = ""
			
			that.vueData = [
				{id:'add1' ,name: "", vue_url: undefined, vue_sort: 1,},
			]
		},
		// 侧边栏确认
		addRequest(){
			let that = this
			// console.log("that.x_parent_id",that.x_parent_id)
			// console.log("that.x_title",that.x_title)
			// console.log("that.x_uri",that.x_uri)
			console.log("that.vueData",that.vueData)
			
			
			let vvv = true
			that.vueData.forEach(function(res,index){
				if(!res.vue_url){
					vvv = false
				}
			})
			console.log("vvv",vvv)
			
			// 去重检查
			let names = that.vueData.map(item => item["vue_url"]);
			let nameSet = new Set(names);
			let ccc = true // true表示无重复
			if (nameSet.size == names.length) {
			    console.log("无重复");
			} else {
				ccc = false
			    console.log("有重复")
			}
			
			
			if(!(that.x_parent_id >= 0)){
				that.add_form_hint = "请选择 父级"
			}
			else if(!that.x_title){
				that.add_form_hint = "请填写 标题"
			}
			// else if(!vvv){
			// 	that.add_form_hint = "请选择 vue页面跳转路径"
			// }
			else if(!ccc){
				that.add_form_hint = "vue路径有重复"
			}
			
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
			
				// 要按照序号的大小顺序请求，要排序
				that.vueData.sort(function(a,b){return a.vue_sort - b.vue_sort})
				let vue_arr_id = []
				that.vueData.forEach((res,index)=>{
					// let obj = {
					// 	// name: res.name,
					// 	vue_url: res.vue_url
					// }
					vue_arr_id.push(res.vue_url)
				})
				console.log("vue_arr_id",vue_arr_id);
				
				let r_data = {
					parent_id : that.x_parent_id,
					title : that.x_title,
					uri : that.x_uri,
					vue_ids : vue_arr_id,
					role_ids : that.x_role_ids,
					order: Number(that.x_order)
				}
				if(that.x_show){
					r_data.show = 1 // 显示
				}
				else {
					r_data.show = 0 // 隐藏
				}
				if(that.drawer_title === "新增"){
					menuAdd(r_data).then(res=>{
						console.log("侧边栏新增",res)
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('新增成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "新增失败");
						}
					})
				}
				else if(that.drawer_title === "编辑"){
					r_data.id = that.x_id
					
					menuEdit(r_data).then(res=>{
						console.log("侧边栏编辑",res)
						that.add_button_loading = false
						
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('编辑成功');
							that.searchButton()
							
							// 更新一下home页的菜单栏
							that.$bus.$emit("updateNav",1);
						}
						else {
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
				}
				
			}
			
		},
		
		// 侧边栏父级选择
		handleChangeA(e){
			console.log(e);	
			this.x_parent_id = e
		},
		// 角色下拉
		handleChangeB(value) {
			this.x_role_ids = value
		    console.log(value);
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		
		// 侧边栏显示隐藏按钮
		showChange(e){
			let that = this
			console.log(e);
			that.x_show = e
		},
		// 表格里的显示隐藏按钮
		showHideButton(e){
			this.editButton(e)
		},
		
		// 侧边栏，vue路径选择
		handleChangeV(e,index){
			console.log(e,index)
			let that = this
			// this.x_vue_url = e
			this.vueData[index].vue_url = e
			// 获取路由对应的名字/页面标题
			// this.vueUrl.forEach(function(res_r,index_r){
			// 	if(res_r.path == e){
			// 		that.vueData[index].name = res_r.name
			// 	}
			// })
		},
		
		// 添加vue路径
		addVueUrl(){
			let obj = {
				id: 'add' + new Date().getTime(),
				// name: "",
				vue_url: undefined,
			}
			obj.vue_sort = this.vueData[this.vueData.length - 1].vue_sort + 1
			this.vueData.push(obj)
		},
		// 删除vue路径
		delVueUrl(e,index){
			if(this.vueData.length > 1){
				this.vueData.splice(index,1)
			}
		},
		// vue排序值。仅用于前端排序，后端用不到这个
		vueSort(e,item_v){
			console.log(e);
			item_v.vue_sort = e
		},
		// 整理vue路径的排序
		sortVueUrl(){
			let that = this
			that.vueData.sort(function(a,b){return a.vue_sort - b.vue_sort})
		}
	}
}	
</script>

<style scoped>
.content-box {
	margin-top: 15px;
	border: 1px solid #d9d9d9;
	border-radius: 6px;
	overflow: hidden;
}
.first-title-box,
.title-box {
	position: relative;
	display: flex;
	align-items: center;
	user-select:none;
	padding: 10px;
}
.first-title-box {
	background-color: #fafafa;
	border-bottom: 1px solid #d9d9d9;
	cursor: pointer;
}

.title-box:hover {
	background-color: #f5f5f5;
}


.first-title-icon {
	font-size: 12px;
	margin-right: 10px;
}
.second-title-icon {
	font-size: 12px;
	margin-right: 10px;
}


.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.class-title {
	position: relative;
	font-size: 14px;
	margin-right: 25px;
	width: 80px;
	color: #333;
	text-align: right;
}

/* 必填提示 */
.required-hint {
	color: red;
	position: absolute;
	right: -8px;
}
</style>